import { Routes } from '@angular/router';
import { LandingComponent } from './landing.component';

export const LANDING_ROUTES: Routes = [
    {
        path: '',
        component: LandingComponent,
    }
];
